import { Component } from '@angular/core';
import { PagesService } from '@app/_services/pages.service';
import { AuthenticationService } from '@app/_services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'right-content',
  templateUrl: './right-content.component.html',
  styleUrls: ['./right-content.component.scss']
})
export class RightContentComponent {

  private subscription:Subscription
  public currentPage:any;

  constructor(
    private pagesService: PagesService,
    public authService: AuthenticationService,
  ){}

  ngOnInit(){
    this.subscription = this.pagesService.currentPageSubject.subscribe(
      resp=> {
        this.currentPage = resp;
      }
    )
  }

  ngOnDestoy(){
    this.subscription.unsubscribe();
  }

  get editMode(){
    return this.pagesService.editMode;
  }

  toggleEditMode(){
    this.pagesService.editMode = !this.pagesService.editMode;
  }
  get editable(){
    return this.currentPage&&(this.authService.privileges?.admin|| this.authService.privileges?.editor);
  }
  
}
